
import React, { useState, useEffect, useRef, useMemo } from "react";
import "./Home.css";
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../firebase'; // adjust based on your structure
import { Helmet } from "react-helmet-async";
import FeaturedCardsSection from "../components/FeaturedCardsSection";
import { trackAnalyticsEvent } from "../analytics/siteAnalytics";

const baseSlides = [
  {
    video: "/videos/video1.mp4",
    poster: "/videos/video1.jpg",
    heading: "Innovator. Expert. Problem Solver.",
    subheading: `Go!Foton brings innovation to the global photonics market with decades of expertise in optics and photonics-solving real-world problems for our customers witih a scalable and customizable integration approach. We bring light to life.`, // \n\n
    buttonLink: "/products",
    buttonText: "Our Products"
  },
  {
    video: "/videos/video2.mp4",
    poster: "/videos/video2.png",
    heading: "Connectivity for extraordinary experiences",
    subheading: "Ensuring AI's potential and impact are limitless.",
    buttonLink: "/solutions/datacenter",
    buttonText: "Learn More"
  },
  {
    video: "/videos/video3.mp4",
    poster: "/videos/video3.png",
    heading: "Building broadband at home",
    subheading: "Helping communities connect with BEAD & BABA compliant solutions",
    buttonLink: "/bead",
    buttonText: "Learn More"
  },
  {
    video: "/videos/video5.mp4",
    poster: "/videos/video5.jpg",
    heading: "PEACOC ANY PORT PANEL (APP)",
    subheading: "High-density, future-proof Base-16 fiber connectivity platform",
    buttonLink: "/peacoc-any-port-panel",
    buttonText: "Learn More"
  }
];



function Home() {
  const [activeIndex, setActiveIndex] = useState(0);
  const videoRefs = useRef([]);
  const trackedMarqueeSlidesRef = useRef(new Set());
  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

const [cardsPerView, setCardsPerView] = useState(4)
  const [current, setCurrent] = useState(0);


useEffect(() => {
  const update = () => {
    const w = window.innerWidth;
    if (w < 768) setCardsPerView(1);
    else if (w < 1024) setCardsPerView(2);
    else setCardsPerView(3); // or 4 if you want
  };

  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);


useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };
  window.addEventListener("resize", handleResize);
  console.log('isMobile?', isMobile)
  return () => window.removeEventListener("resize", handleResize);
}, []);

useEffect(() => {
    // signal to Prerender.io that the page is ready to snapshot
    if (typeof window !== "undefined") {
      window.prerenderReady = true;
    }
  }, []);

  useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

// pick an image field that exists for a product
const getProductImage = (p) => {
  const candidates = [p.image, p.cardImage, p.featuredImage, p.image1, p.imageUrl].filter(Boolean);
  return candidates[0] || null;
};

const [tradeshows, setTradeshows] = useState([]);

useEffect(() => {
  const loadTradeshows = async () => {
    const snapshot = await getDocs(
      collection(db, "tradeshows")
    );

    setTradeshows(
      snapshot.docs.map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }))
    );
  };

  loadTradeshows();
}, []);

const featuredTradeShow = useMemo(() => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const thirtyDaysFromNow = new Date(today);
  thirtyDaysFromNow.setDate(
    thirtyDaysFromNow.getDate() + 30
  );

  return tradeshows
    .filter((show) => {
      if (
        show.active === false ||
        !show.startDate ||
        !show.endDate
      ) {
        return false;
      }

      const start = new Date(
        `${show.startDate}T12:00:00`
      );

      const end = new Date(
        `${show.endDate}T23:59:59`
      );

      /*
       * Show starts within next 30 days
       * OR show is currently happening.
       * Immediately disappears after end date.
       */
      return (
        today <= end &&
        start <= thirtyDaysFromNow
      );
    })
    .sort(
      (a, b) =>
        new Date(a.startDate) -
        new Date(b.startDate)
    )[0] || null;
}, [tradeshows]);

const slides = useMemo(() => {
  if (!featuredTradeShow) {
    return baseSlides;
  }

  const tradeShowSlide = {
    video: "",
    poster:
      featuredTradeShow.backgroundImageUrl ||
      "/videos/tradeshowAlternate.png",

    heading:
      featuredTradeShow.heroHeading ||
      featuredTradeShow.name,

    subheading:
      featuredTradeShow.heroDescription ||
      `${featuredTradeShow.location || ""}${
        featuredTradeShow.booth
          ? ` | Booth ${featuredTradeShow.booth}`
          : ""
      }`,

    buttonLink:
      `/${featuredTradeShow.slug || featuredTradeShow.id}`,

    buttonText: "Learn More",

    isTradeshow: true,
  };

  return [
    tradeShowSlide,
    ...baseSlides,
  ];
}, [featuredTradeShow]);

useEffect(() => {
  const slide = slides[activeIndex];

  if (!slide || document.visibilityState !== "visible") return;

  const slideKey = `${slide.heading}|${slide.buttonLink}`;

  if (trackedMarqueeSlidesRef.current.has(slideKey)) return;

  trackedMarqueeSlidesRef.current.add(slideKey);

  trackAnalyticsEvent("home_marquee_impression", {
    slideIndex: activeIndex,
    slideHeading: slide.heading,
    slideLink: slide.buttonLink,
    isTradeshow: slide.isTradeshow === true,
  });
}, [activeIndex, slides]);

// Build slider items from ALL families (top product by lowest rank)
const familySlides = useMemo(() => {
  const byFamily = new Map();

  for (const p of filteredProducts) {
    const fam = (p.productFamily || "").trim();
    if (!fam) continue;

    const current = byFamily.get(fam);
    const r = Number(p.rank ?? Infinity);
    const cr = Number(current?.rank ?? Infinity);
    if (!current || r < cr) byFamily.set(fam, p);
  }

  // map to the shape your slider expects
  return Array.from(byFamily.entries())
    .map(([family, topProduct]) => ({
      title: family,
      image: getProductImage(topProduct),
      slug: `/${family.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`,
    }))
    .sort((a, b) => a.title.localeCompare(b.title)); // optional sort
}, [filteredProducts]);

// use familySlides length
const maxIndex = Math.max(0, familySlides.length - cardsPerView + 1);


  const goPrev2 = () => setCurrent((i) => Math.max(0, i - 1));
  const goNext2 = () => setCurrent((i) => Math.min(maxIndex, i + 1));
  const goTo   = (i) => setCurrent(Math.min(Math.max(i, 0), maxIndex));


const AUTO_SLIDE_TIME = 3000;
const MANUAL_SLIDE_TIME = 5000;

const [marqueeDelay, setMarqueeDelay] = useState(AUTO_SLIDE_TIME);

useEffect(() => {
  const timer = setTimeout(() => {
    setActiveIndex((prev) => (prev + 1) % slides.length);

    // After an automatic transition, go back to normal 3-second timing
    setMarqueeDelay(AUTO_SLIDE_TIME);
  }, marqueeDelay);

  return () => clearTimeout(timer);
}, [activeIndex, marqueeDelay]);

const goNext = () => {
  setMarqueeDelay(MANUAL_SLIDE_TIME);
  setActiveIndex((prev) => (prev + 1) % slides.length);
};

const goPrev = () => {
  setMarqueeDelay(MANUAL_SLIDE_TIME);
  setActiveIndex((prev) => (prev - 1 + slides.length) % slides.length);
};

const goToMarqueeSlide = (index) => {
  // User intentionally selected a slide, so give them longer to read it
  setMarqueeDelay(MANUAL_SLIDE_TIME);
  setActiveIndex(index);
};


  useEffect(() => {
  if (videoRefs.current[activeIndex]) {
    videoRefs.current[activeIndex].play().catch((err) => {
      console.log("play error", err);
    });
  }
}, [activeIndex]);

const productFamilies = [
  'Fiber Cable Assemblies',
  'Passive Optical Components',
  // 'Cassettes',
  'Fiber Panels',
  'Frames',
];

const topByFamily = useMemo(() => {
  const byFamily = new Map();

  for (const p of filteredProducts) {
    const fam = (p.productFamily || "").trim();
    if (!fam) continue;

    const best = byFamily.get(fam);
    const rank = Number(p.rank ?? Infinity);
    const bestRank = Number(best?.rank ?? Infinity);

    if (!best || rank < bestRank) {
      byFamily.set(fam, p);
    }
  }// turn Map -> array; sort alphabetically (optional)
  return Array.from(byFamily.entries())
    .map(([family, topProduct]) => ({ family, topProduct }))
    .sort((a, b) => a.family.localeCompare(b.family));
}, [filteredProducts]);

  return (
    <>
      <Helmet>
        <title>Go!Foton – Home</title>
        <meta name="description" content="Optical solutions for data centers, telecom, and more." />
        <meta property="og:title" content="Go!Foton" />
        <meta property="og:description" content="Optical solutions for data centers, telecom, and more." />
        <meta property="og:image" content="/public/images/aboutPage.png" />
        
        <meta property="og:url" content="https://gofoton.com/" />
      </Helmet>

    <div className="marquee-carousel">
      {slides.map((slide, index) => (
        <div
          className={`marquee-slide ${index === activeIndex ? "active" : ""}`}
          key={index}
        >
        <video
          disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback"
          ref={(el) => (videoRefs.current[index] = el)}
          src={slide.video}
          poster={slide.poster}
          autoPlay={index === activeIndex}
          loop
          muted
          playsInline
        />

        {slide.isTradeshow && (
          <img
            src="/images/gofoton overlay purple.png"
            alt=""
            className="tradeshow-marquee-overlay"
            aria-hidden="true"
          />
        )}

        <div className="overlay-content">
            <h1>{slide.heading}</h1>
            <p>{slide.subheading}</p>
            <a
              href={slide.buttonLink}
              data-analytics="home_marquee_button"
              data-analytics-label={slide.heading}
              className="cta-button"
            >
              {slide.buttonText}
            </a>
          </div>
        </div>
      ))}

{!isMobile && (
  <>
    <button
      className="arrow left"
      onClick={goPrev}
      aria-label="Previous slide"
    >
      &#10094;
    </button>

    <button
      className="arrow right"
      onClick={goNext}
      aria-label="Next slide"
    >
      &#10095;
    </button>
  </>
)}

<div className="dots">
  {slides.map((_, i) => (
    <button
      key={i}
      type="button"
      aria-label={`Go to slide ${i + 1}`}
      className={`dot ${i === activeIndex ? "active" : ""}`}
      onClick={() => goToMarqueeSlide(i)}
    />
  ))}
</div>
    </div>

<svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>






        <section className="first-section">
        <h2 className="header2">We bring fiber optics to every industry</h2>
        <p>
            With expertise across diverse industries, Go!Foton delivers cutting-edge fiber optic solutions tailored to your unique needs. We illuminate the path to innovation, ensuring your business stays connected and competitive.
        </p>

        <div className="industries-grid">
            <div className="industry-card">
            <img src="/images/hometile1.jpg" alt="Data Centers" />
            <div className="industry-content">
                <h3>Data Centers</h3>
                <p style={{marginBottom: 25}}>Optimize your infrastructure with scalable fiber optic solutions.</p>
                <a href="/solutions/datacenter" data-analytics="home_datacenter_industry_button" className="cta-button">Read More</a>
            </div>
            </div>
            <div className="industry-card">
            <img src="/images/solutions/ai.jpg" alt="AI" />
            <div className="industry-content">
                <h3>AI</h3>
                <p style={{marginBottom: 25}}>Your home for AI data center fiber infastructure</p>
                <a href="/solutions/ai" data-analytics="home_ai_industry_button" className="cta-button">Read More</a>
            </div>
            </div>
            <div className="industry-card">
            <img src="/images/hometile3.webp" alt="Imaging" />
            <div className="industry-content">
                <h3>Medical Imaging</h3>
                <p style={{marginBottom: 25}}>Achieve precision with advanced optical imaging technologies.</p>
                <a href="/solutions/medical-imaging" data-analytics="home_medical_imaging_industry_button" className="cta-button">Read More</a>
            </div>
            </div>
            <div className="industry-card">
            <img src="/images/hometile2.jpg" alt="Telecom & MSO" />
            <div className="industry-content">
                <h3>Central Office/Headend</h3>
                <p style={{marginBottom: 25}}>Enhance connectivity with reliable fiber networks.</p>
                <a href="/solutions/central-office" data-analytics="home_central_office_industry_button" className="cta-button">Read More</a>
            </div>
            </div>
            
        </div>


        </section>


       <center><a href="/solutions" data-analytics="home_view_all_solutions_button" className="cta-button" style={{ top: 300 }}>VIEW ALL SOLUTIONS</a></center> 


            <section className="values-section">
        <h2 className="header2">We’re on a mission to bring light to life</h2>
        <p style={{marginBottom: 30}}>
            The demand for photonics and optics spans industries, applications, and enhances our experiences every day. We imagine how to solve problems in unique ways for our customer’s unique needs. When choosing Go!Foton, trust we’ll put you first, care about your experience, ensure our interests are aligned as we innovate via the right dimension, making data-backed decisions that deliver results.
        </p>

                <a href="/about" data-analytics="home_about_us_button" className="cta-button">About Us</a>
            <div className="values-grid">
                {[
                {
                    front: "People first, integrity centered",
                    back: "Great things happen when we support one another’s strengths to solve problems.",
                    image: "/images/title1.jpg",
                },
                {
                    front: "Innovation via the right dimension",
                    back: "We aim to understand your point of view and create solutions that bring you value.",
                    image: "/images/title2.jpg",
                },
                {
                    front: "Customer experience",
                    back: "Our goal is to delight. That’s why our customers turn to us again and again.",
                    image: "/images/title3.jpg",
                },
                {
                    front: "Data-supported decision making",
                    back: "Make the best decision by considering all available information and needs.",
                    image: "/images/title4.jpeg",
                },
                {
                    front: "Interest alignment",
                    back: "Let’s win together. The best outcomes are achieved when everyone involved benefits.",
                    image: "/images/title5.jpg",
                },
                {
                    front: "Results delivered",
                    back: "We set aggressive objectives because we dare to be the best and we’re driven to achieve.",
                    image: "/images/title6.jpeg",
                },
                ].map((tile, idx) => (
                <div className="flip-card" key={idx}>
                    <div className="flip-card-inner">
                    <div className="flip-card-front">
                        <img src={tile.image} alt={tile.front} />
                        <div className="tile-caption">{tile.front}</div>
                    </div>
                    <div className="flip-card-back">
                        <p>{tile.back}</p>
                    </div>
                    </div>
                </div>
                ))}
            </div>
            </section>

<FeaturedCardsSection variant="home" isMobile={isMobile} />

      {/* <p className="solution-products-section-description">Our innovative fiber optic solutions are engineered to support the evolving demands of your networks, ensuring superior speed, efficiency, and adaptability.</p> */}
<section className="milestones-carousel">
 <h2>Our Featured Solutions</h2>
      <div className="milestones-wrapper" style={{marginTop: 30}}>
<div className="milestones-viewport">
  <button
    className="milestones-arrow milestones-arrow--prev"
    onClick={goPrev2}
    aria-label="Previous"
    disabled={current === 0}
  >
    ‹
  </button>

  <div
    className="milestones-track"
    style={{
      "--cards": cardsPerView,
      transform: `translateX(-${(100 / cardsPerView) * current}%)`,
    }}
  >
    {familySlides.map((s, idx) => (
      <article className="milestones-card-home" key={idx}>
        <center>
          <img src={s.image} alt={s.title} style={{ width: "100%", height: 200, objectFit: "cover" }} />
          <h3>{s.title}</h3>
          <a href={s.slug} data-analytics="home_product_family_button" data-analytics-label={s.title} className="cta-button">Learn More</a>
        </center>
      </article>
    ))}
  </div>

  <button
    className="milestones-arrow milestones-arrow--next"
    onClick={goNext2}
    aria-label="Next"
    disabled={current === maxIndex}
  >
    ›
  </button>
</div>

      </div>

      <div className="milestones-dots">
        {Array.from({ length: maxIndex + 1 }).map((_, i) => (
          <span
            key={i}
            className={`milestones-dot ${i === current ? "is-active" : ""}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>
    </section>


        <div className="curved-footer">
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
        
    </>
  );
}

export default Home;
